import { apiGeneral } from './_General';

export const apiNewsLetter = {
    addNewsletterSubscription: (email, token, cb, eCb) => {
        apiGeneral.apiPost('newsletter_subscriptions', email, token, cb, eCb);
    }
}
